class IOSandbox {
  constructor() {
    this.events = [];
    this.socketId = null;
  }
  connect(url, callback, events) {
    this.events = events;
    callback();
  }
  send(sid, label, ...data) {
    if (!sid || sid == this.socketId) {
      if (this.events[label]) {
        if (label == "end") {
          data = data.map(clonePacketValue);
        }
        this.events[label].apply(undefined, data);
      }
    }
  }
  broadcast(sid, label, ...data) {
    this.send(null, label, ...data);
  }
  broadcastEx(sid, label, ...data) {
    if (sid != this.socketId) {
      this.send(null, label, ...data);
    }
  }
}
function clonePacketValue(value) {
  if (!value || typeof value != "object") {
    return value;
  }
  if (typeof structuredClone == "function") {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value));
}
module.exports = IOSandbox;